var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1976d2",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216,36H168V28a12,12,0,0,0-12-12H100A12,12,0,0,0,88,28v8H40A20,20,0,0,0,20,56V216a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36ZM96,28a4,4,0,0,1,4-4h56a4,4,0,0,1,4,4v8H96ZM228,216a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V56A12,12,0,0,1,40,44H216a12,12,0,0,1,12,12ZM160,112H96a4,4,0,0,1,0-8h64a4,4,0,0,1,0,8Zm0,32H96a4,4,0,0,1,0-8h64a4,4,0,0,1,0,8Zm0,32H96a4,4,0,0,1,0-8h64a4,4,0,0,1,0,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutList);
export default __webpack_public_path__ + "static/media/payout_list.65ca770365196fde1e5312fe2b57684c.svg";
export { ForwardRef as ReactComponent };